const lang = {
    "Kep": "QES",
    "KepNotLinked": "Twój podpis kwalifikowany nie jest jeszcze powiązany z kontem. Zaloguj się jak zwykle, a my go powiążemy.",
    "KepNewAccount": "Nie masz konta? Zarejestruj się",
    "KepLinked": "Podpis kwalifikowany powiązany z kontem",
    "KepLinkFailed": "Nie udało się powiązać podpisu kwalifikowanego. Zaloguj się nim ponownie, a my go powiążemy",
    "KepFile": "Plik klucza",
    "ErrorKepLogin": "Nie udało się zalogować podpisem kwalifikowanym",
    "EnterWidth": "Zaloguj się z:",
    "Registration": "Zarejestrować",
    "enter": "Wejść",
    "EntrWidthEmailOrPhone": "Zaloguj się za pomocą adresu e-mail lub telefonu",
    "login": "Upoważnienie",
    "NoAkkGoReg": "Rejestr",
    "Password": "Hasło",
    "Name": "Nazwać",
    "LastName": "Nazwisko",
    "Phone": "Aby się zarejestrować wpisz swój numer telefonu",
    "Email": "Poczta",
    "RepeatPassword": "Powtórz hasło",
    "Сancel": "Anulować",
    "Save": "Ratować",
    "Language": "Język",
    "ConfirmThisMail": "Twój email został potwierdzony",
    "Saved": "Zapisane",
    "Error": "Błąd",
    "FillInAllTheFields": "Wypełnij wszystkie pola",
    "Next": "Dalej",
    "MinPassLength": "Minimalna długość hasła 4 znaków",
    "ForgotYourPassword": "Zapomniałeś hasła",
    "RestorePassword": "Proszę ustawić nowe hasło.",
    "UserMustBeRegistered": "Użytkownik musi być zarejestrowany",
    "Confirm": "Potwierdzać",
    "WrongFormat": "Zły format",
    "WrongPassword": "niepoprawne hasło",
    "WrongLoginOrPassword": "zły login lub hasło",
    "PhoneAlreadyRegistered": "Telefon już zarejestrowany",
    "EmailAlreadyRegistered": "Poczta już zarejestrowana",
    "FillInTheFieldsCorrectly": "Poprawnie wypełnij pola",
    "ThisAccountDoesNotExist": "to konto nie istnieje",
    "LinkIsNotValid": "Link jest nieprawidłowy",
    "AMessageHasBeenSentToTheSpecifiedLogin": "Wiadomość została wysłana do podanej nazwy użytkownika",
    "IncorrectCaptcha": "błędny kod weryfikacyjny",
    "CaptchaIsNotValid": "Captcha nie jest już ważny",
    "EnterCaptcha": "Wpisz captcha",
    "EnterSMS": "Wpisz kod z SMS-a",
    "SMSCodeIsNoLongerValid": "Kod SMS jest już nieważny",
    "SMSCodeIsIncorrect": "Kod SMS jest nieprawidłowy",
    "MailNotVerifiedLinkTimedOut": "Wiadomość nie potwierdzona, link wygasł",
    "DemoLogin": "Logowanie do wersji demonstracyjnej",
    "AreYouSureYouWantToEnterTheDemoForEvaluation": "Czy na pewno chcesz wziąć udział w <b> demo </b> , aby to wypróbować?",
    "FillInAdditionalInformation": "Uzupełnij dodatkowe informacje",
    "ToCompleteRegistration": "Aby zakończyć rejestrację",
    "LinkThirdPartyServices": "Połącz usługi stron trzecich",
    "Complete": "Ukończyć",
    "AccountAlreadyLinked": "Konto już połączone",
    "AccountNotRegistered": "Konto niezarejestrowane",
    "NotMyNumber": "Nie mój numer",
    "Back": "Z powrotem",
    "numberOfAttemptsToCheckAuth": "Liczba prób logowania:",
    "InvalidPassNumberOfAttemptsToCheckAuth": "Błędne hasło, liczba prób logowania:",
    "TryAgainAfterMinute": "Spróbuj ponownie za 2 minuty",
    "Help": "Wsparcie",
    "y": "tak",
    "n": "Nie",
    "doYouConfirmEmail": "Czy na pewno chcesz zmienić swój adres e-mail?",
    "success": "Z powodzeniem",
    "goToAutorize": "Przejdź do autoryzacji",
    "UserEmailAlreadyExists": "Użytkownik z tym adresem email już istnieje",
    "UserPhoneAlreadyExists": "Użytkownik o tym numerze telefonu już istnieje",
    "TermOfUse": "Warunki korzystania",
    "PrivacyPolicy": "Polityka prywatności",
    "accountNotRegistered": "konto niezarejestrowane",
    "wantToReg": "Chcesz się zarejestrować?",
    "weSuccessChangeYouEmail": "Pomyślnie zmieniliśmy Twój adres e-mail",
    "youCanCloseThisWindow": "Możesz zamknąć to okno",
    "countryConfirm": "Potwierdzenie kraju",
    "EmailAlreadyTied": "Poczta jest już połączona z innym kontem",
    "areYourCountry": "czy to twój kraj?",
    "EmergencyEntrance": "Stara autoryzacja",
    "enterCorrectNumber": "Wprowadź numer w formacie międzynarodowym",
    "thisPhoneRegister": "Ten numer telefonu jest już zarejestrowany w systemie",
    "wantUsePhoneForAuth": "Czy chcesz się zalogować przy użyciu tego numeru telefonu?",
    "ok": "Ok",
    "regAgree": "Rejestrując konto, akceptuję",
    "wantBind": "Chcesz się zalogować i połączyć usługę",
    "bind": "wiązać",
    "yoursMailBinded": "Twój adres e-mail znajduje się na istniejącym koncie",
    "wantUsePhoneAndBind": "już zarejestrowany w systemie",
    "notGetDataFromApple": "Nie udało się odebrać danych od Apple",
    "ErrorAppleLogin": "Błąd autoryzacji za pośrednictwem Apple",
    "ErrorGoogleLogin": "Błąd autoryzacji przez Google",
    "ErrorTelegramLogin": "Błąd podczas logowania przez Telegram",
    "ErrorFacebookLogin": "Błąd logowania przez Facebook",
    "EMailOrPhone": "Proszę wpisać prawidłowy numer telefonu lub adres e-mail.",
    "withoutName": "Bez nazwy",
    "goToCabinet": "Do biura",
    "Logout": "Zakończ sesję",
    "creationDate": "Data utworzenia",
    "preparingCompany1": "Tworzymy Twoją firmę, proszę daj nam chwilę...",
    "preparingCompany2": "Przygotowujemy interfejs do zarządzania towarami i usługami...",
    "preparingCompany3": "Pracujemy nad wygodną księgowością finansową...",
    "preparingCompany4": "Dokonujemy ostatnich ustawień, prawie gotowe...",
    "companyBlocked": "Ta firma jest nieaktywna",
    "youBlockedInComp": "Użytkownik nie jest aktywny, logowanie nie jest możliwe",
    "loginTitle": "Wszystko, czego potrzebuje firma, w jednym miejscu",
    "loginDescr": "Automatyzacja sklepów, kawiarni, usług dostawczych, restauracji, magazynów, produkcji lub usług",
    "NoAkkGoRegText": "Nie masz konta?",
    "LoginPlaceholder": "Proszę podać wymagane informacje",
    "loginText": "Masz już konto?",
    "and": "I",
    "AcceptTheTerms": "Prosimy o zaakceptowanie polityki prywatności i warunków użytkowania",
    "CountryPhoneFormat": "Jeśli nie jest to Twój kraj, sprawdź, czy wpisałeś numer telefonu we właściwym formacie międzynarodowym.",
    "SaveNewPassword": "Zapisz nowe hasło"
}

export default function() {
    return lang;
}